import { makeDefaultFilter } from '@@partner:helpers/crud/filters'
import { FeedbacksFiltersType } from '@components/feedback/grid/FeedbacksFilter'

export const prepareFeedbacksFilter = (filters: FeedbacksFiltersType) => {
  const idsFilter =
    filters.ids.length > 0
      ? {
        fields: [ 'id' ],
        op: 'contains',
        value: filters.ids
      }
      : makeDefaultFilter('id')

  const orderIdsFilter =
    filters.orderIds.length > 0
      ? {
        fields: [ 'order_id' ],
        op: 'contains',
        value: filters.orderIds
      }
      : makeDefaultFilter('order_id')

  const generalRatingFilter =
    filters.generalRating.length > 0
      ? {
        fields: [ 'general_rating' ],
        op: 'contains',
        value: filters.generalRating
      }
      : makeDefaultFilter('general_rating')

  const hasImagesFilter = filters.hasImages
    ? { fields: [ 'images' ], op: 'not_null', value: '' }
    : makeDefaultFilter('images')

  const needCallFilter =
    filters.needCall !== ''
      ? {
        fields: [ 'need_call' ],
        op: 'eq',
        value: [ Boolean(Number(filters.needCall)) ]
      }
      : makeDefaultFilter('need_call')

  const shopFilter =
      filters.shop_id && filters.shop_id?.length > 0
        ? {
          fields: [ 'shop_id' ],
          op: 'contains',
          value: filters.shop_id
        }
        : makeDefaultFilter('shop_id')

  return {
    and: [
      idsFilter,
      orderIdsFilter,
      generalRatingFilter,
      hasImagesFilter,
      needCallFilter,
      shopFilter
    ]
  }
}
